/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeEvery, delay, put } from 'redux-saga/effects';

import { SHOW_APP_ERROR, CLEAR_APP_ERROR } from '../reducers/app';

function* handleShowAppError(action: any) {
  const { hideAfter } = action;
  yield delay(hideAfter * 1000);
  yield put({ type: CLEAR_APP_ERROR });
}

export function* appErrorSaga() {
  yield takeEvery(SHOW_APP_ERROR, handleShowAppError);
}
